var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-logo"},[_c('a',{staticClass:"header-logo-link",attrs:{"href":"https://dyson-service.kz"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }